<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <div class="row">
          <div class="col-md-4 link-column">
            <ul>
              <li class="title">
                AutoEdge 24
              </li>
              <li>
                <router-link to="/">
                  Home
                </router-link>
              </li>
              <li>
                <router-link to="/tires">
                  Reifen
                </router-link>
              </li>
              <li>
                <router-link to="/shop">
                  Shop
                </router-link>
              </li>
              <li>
                <router-link to="/legal">
                  Impressum
                </router-link>
              </li>
              <li>
                <router-link to="/terms">
                  AGBs
                </router-link>
              </li>
              <li>
                <router-link to="/privacy">
                  Datenschutzerklärung
                </router-link>
              </li>
              <li>
                <router-link to="/accessibility">
                  Barrierefreiheit
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-4 link-column">
            <ul>
              <li class="title">
                Social Media
              </li>
              <li class="social-media">
                <a
                  href="https://www.instagram.com/autoedge24"
                  target="_blank"
                >
                  <div class="icon-container">
                    <span class="mdi mdi-instagram"></span>
                  </div>
                  <span class="ml-1">Folgen Sie uns auf Instagram</span>
                </a>
              </li>
              <li class="social-media">
                <a
                  href="https://wa.me/4917655980480"
                  target="_blank"
                >
                  <div class="icon-container">
                    <span class="mdi mdi-whatsapp"></span>
                  </div>
                  <span class="ml-1">Kontaktieren Sie uns per Whatapp</span>
                </a>
              </li>
              <li class="social-media">
                <a
                  href="https://www.tiktok.com/@autoedge.24"
                  target="_blank"
                >
                  <div class="icon-container">
                    <img class="logo-img" src="img/logos/TikTok_logo_transparent.png" alt="Tiktok Logo" />
                  </div>
                  <span class="ml-1">Folgen Sie uns auf Tiktok</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 link-row">
            <ul>
              <li class="title">
                Versand und Zahlungsmethoden
              </li>
              <li>
                <a
                  href="https://www.paypal.com"
                  target="_blank"
                >
                  <div class="logo-container paypal">
                    <img src="https://www.paypalobjects.com/webstatic/de_DE/i/de-pp-logo-150px.png" alt="PayPal Logo" />
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="https://www.dhl.de"
                  target="_blank"
                >
                  <div class="logo-container dhl">
                    <img src="img/logos/DHL_logo.svg">
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="https://www.dpd.de"
                  target="_blank"
                >
                  <div class="logo-container dpd">
                    <img src="img/logos/DPD_logo.png">
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="copyright mt-4">
        &copy; {{ year }}, Designed by
        <a href="https:///www.invisionapp.com" target="_blank" rel="noopener"
          >Invision</a
        >. Coded by
        <a href="https://binarcode.com" target="_blank" rel="noopener"
          >BinarCode</a
        >
        and
        <a href="https://www.creative-tim.com" target="_blank" rel="noopener"
          >Creative Tim</a
        >.
      </div>
    </div>
    <cookie-law
      :buttonText="'Akzeptieren'">
      <div slot="message">
        Diese Seite nutzt Cookies, um Ihnen die optimale Nutzung dieser Seite zu ermöglichen.
        <router-link to="privacy">Weitere Informationen</router-link>
      </div>
    </cookie-law>
  </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law'

export default {
  props: {
    backgroundColor: String,
    type: String
  },
  components: {
    CookieLaw
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
}
.link-row {
  .title {
    display: block;
  }
  li {
    display: inline-block;
  }
}

.logo-container {
  width: 100px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    padding: 4px;
    max-width: 100%;
    max-height: 100%;
  }
  
  &.dhl {
    background-color: #ffcc00;
  }
  &.paypal {
    background-color: white;
  }
  &.dpd {
    background-color: white;
  }
}

.social-media {
  span {
    text-transform: none !important;
  }
  a {
    display: flex;
    align-items: center;
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .icon-container {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo-img {
    height: 100%;
    width: 100%;
  }
  .mdi {
    height: 100%;
    width: 100%;
    font-size: 20px;
    line-height: 24px;
  }
}
</style>
